import React, {useState, useEffect} from 'react';
import Planning from './screens/planning/planning.jsx';
import Review from './screens/review/review.jsx';
import {teethInitialState} from './components/common/teeth';
import fields from './components/user-details/fields';

function App() {

    useEffect(()=>{
        const handleResize =()=>{
            const isMobileCurrent = (window.innerWidth < 1050);
            setIsMobile(isMobileCurrent);
        }
        handleResize();
        window.addEventListener('resize', handleResize);
    },[])


  const [isMobile, setIsMobile] = useState(false);
  const [teethState, setTeethState] = useState(teethInitialState);
  const [bridges, setBridges] = useState([]); //{type: "process", teeth: [17, 12], status: null}]
  const [type, setType] = useState(null);//null
  const [appState, setAppState] = useState("open");
  const [activeTeeth, setActiveTeeth ] = useState([]);
  const [currency, setCurrency ] = useState("dollars");
  const [curScreen, setCurScreen ] = useState("planning");
  const [appFiles, setAppFiles ] = useState([]);

    const fieldForState = {};
    for(const field in fields){
        fields[field].map(item=>{fieldForState[item.id] = ""});
    }
  const [fieldsState, setFields] = useState(fieldForState);

  return (
    <div className="App">

        {isMobile && <div className='abra-mobile'>{abraStr.isMobile}</div> }
        {!isMobile &&
        <>
        <p
            style={{marginTop:"-40px",cursor:"pointer",display:"none"}}
            onClick={()=>{
                setCurScreen(prevState => {
                    return  curScreen === "planning"? "review" : "planning"
                })
            }}
        >change view</p>

        {curScreen === "planning" &&
        <Planning
            teethState={teethState}
            setTeethState={setTeethState}
            bridges={bridges}
            setBridges={setBridges}
            type={type}
            setType={setType}
            appState={appState}
            setAppState={setAppState}
            activeTeeth={activeTeeth}
            setActiveTeeth={setActiveTeeth}
            currency={currency}
            setCurrency={setCurrency}
            curScreen={curScreen}
            setCurScreen={setCurScreen}
            fieldsState={fieldsState}
            setFields={setFields}
        />
        }
        {curScreen === "review" &&
        <Review
            teethState={teethState}
            bridges={bridges}
            currency={currency}
            setCurScreen={setCurScreen}
            setCurrency={setCurrency}
            fieldsState={fieldsState}
            setFields={setFields}
            appFiles={appFiles}
            setAppFiles={setAppFiles}
        />
        }
        </>
        }
    </div>
  );
}

export default App;